<template>
  <el-card shadow="hover">
    <div style="padding: 10px 20px" v-loading="loading">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="门店名称" prop="name">
            <el-input placeholder="请输入门店名称" v-model="editModel.name"></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="供货仓库"
            v-if="!editModel.optStorehouse"
            prop="storehouseGuid"
          >
            <customer-storehouse-select
              v-model="editModel.storehouseGuid"
              :excludeGuids="!!editModel.guid ? [editModel.guid] : []"
              :defaultFirst="true"
            />
            <el-checkbox
              v-model="editModel.optControl"
              v-if="!editModel.optStorehouse"
              :true-label="1"
              :false-label="0"
            >
              <span style="color: #919191">
                严控模式，门店只允许从中心仓库采购
              </span>
            </el-checkbox>
          </el-form-item> -->
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              maxlength="128"
              v-model="editModel.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店地址" prop="address">
            <el-input
              type="textarea"
              v-model="editModel.address"
              :rows="2"
              maxlength="512"
              placeholder="输入门店地址信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店坐标" prop="storePos">
            <div class="borderBox">
              <div v-if="editModel.province">
                所在省市区:
                {{
                  [editModel.province, editModel.city, editModel.area]
                    .filter((item) => !!item)
                    .join("-")
                }}
              </div>
              <div v-if="editModel.longitude">坐标经度: {{ editModel.longitude }}</div>
              <div v-if="editModel.latitude">坐标纬度: {{ editModel.latitude }}</div>
              <baidu-pos
                :values="[
                  editModel.longitude,
                  editModel.latitude,
                  editModel.province,
                  editModel.city,
                  editModel.area,
                ]"
                :address="editModel.address"
                @save="handleMapChange"
              ></baidu-pos>
            </div>
          </el-form-item>
          <el-form-item label="负责人姓名" prop="ownerName">
            <el-input
              maxlength="128"
              v-model="editModel.ownerName"
              placeholder="请输入负责人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人电话" prop="ownerTelephone">
            <el-input
              maxlength="128"
              v-model="editModel.ownerTelephone"
              placeholder="请输入负责人电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="证照信息" prop="credentials">
            <x-upload
              type="image"
              imageAlign="start"
              :fileCount="10"
              :fileSize="5 * 1024"
              :imageViewWidth="240"
              :imageViewHeight="180"
              v-model="editModel.credentials"
            ></x-upload>
          </el-form-item>
          <el-form-item label="盘点时间" prop="sheetStartTime">
            <el-date-picker
              type="datetime"
              style="width: 100%"
              value-format="timestamp"
              v-model="editModel.sheetStartTime"
              placeholder="选择盘点开始时间"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="取货密码" prop="h5InventoryPwd">
            <el-input
              type="number"
              v-model="editModel.h5InventoryPwd"
              placeholder="请输入取货密码"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="骑手取货红包" prop="riderRewardAmount">
            <el-input
              type="number"
              v-model="editModel.riderRewardAmount"
              placeholder="请输入骑手取货红包金额"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="排序编号" prop="optSort">
            <el-input
              type="number"
              v-model="editModel.optSort"
              placeholder="请输入排序编号"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
import baiduPos from "../../../../components/baiduPos.vue";
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";

const defaultModel = {
  province: "",
  city: "",
  area: "",
  address: "",
  latitude: "",
  longitude: "",
  sheetStartTime: "",
  optControl: 0,
  optStatus: 1,
};

export default {
  components: {
    baiduPos,
    customerStorehouseSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        customerGuid: [
          {
            required: true,
            message: "请选择商户",
            trigger: "change",
          },
        ],
        storehouseGuid: [
          {
            required: true,
            message: "请选择供货仓库",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入门店名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    handleMapChange(values) {
      this.editModel.longitude = values[0];
      this.editModel.latitude = values[1];
      this.editModel.province = values[2];
      this.editModel.city = values[3];
      this.editModel.area = values[4];
    },
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.store.info.update"
            : "biz.customer.store.info.create";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("保存成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.customerGuid) {
        this.editModel.customerGuid = this.pageParams.customerGuid;
      }
      if (this.pageParams.storehouseGuid) {
        this.editModel.storehouseGuid = this.pageParams.storehouseGuid;
      }
      if (this.pageParams.optStorehouse) {
        this.editModel.optStorehouse = this.pageParams.optStorehouse;
      }
      if (this.editModel.sheetStartTime <= 0) {
        this.editModel.sheetStartTime = "";
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.store.info.detail", {
          guid: this.pageParams.guid,
        })
          .then((resp) => {
            this.editModel = resp.data;
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
